module.exports = __webpack_public_path__ + "img/iMac24inch.6b03af44.webp";